import { useApiUploadRequest } from '../hooks/useApiUploadRequest';

export const ANALYZE_SHAPEFILE_PATH = 'draftplot/analyze-shapefile/';

export type AnalyzeShapefileResponse = {
  columns: string[];
};

type AnalyzeShapefileBodyData = {
  file: File;
};

export const useAnalyzeShapefile = () => {
  const mutation = useApiUploadRequest<undefined, undefined, AnalyzeShapefileBodyData, AnalyzeShapefileResponse>(
    ANALYZE_SHAPEFILE_PATH,
  );

  const submit = async (bodyData: AnalyzeShapefileBodyData) => {
    return mutation.mutateAsync({ bodyData });
  };

  return { submit, isSubmitting: mutation.isPending };
};
